import { FormattedMessage } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex';

import { messages } from './messages';
import styles from './styles.module.less';
import { AddCsvFile } from '../../../../../../components/csv-import/ui/components/add-csv-file';
import { useImportContext } from '../../../../../../components/csv-import/ui/components/import-context';
import { ImportDescription } from '../../../../../../components/csv-import/ui/components/import-description';
import { InitErrors } from '../../../../../../components/csv-import/ui/components/init-errors/init-errors';
import { MappingList } from '../../../../../../components/csv-import/ui/components/mapping-list/mapping-list';
import { StepHeader } from '../../../../../../components/csv-import/ui/components/step-header/step-header';
import { StepSuspense } from '../../../../../../components/csv-import/ui/components/step-suspense/step-suspense';
import { linkIDs } from '../../../../../../services/link-service/links';

const exampleFile = '/s3/marketplaces/shipstation/SupplierImportSample.csv';

export const ConfigStepBody = () => {
  const { isGetMappingsLoading, isInitImportLoading } = useImportContext();

  return (
    <StepSuspense isLoading={isGetMappingsLoading || isInitImportLoading}>
      <StepHeader>
        <FormattedMessage {...messages.uploadFile} />
      </StepHeader>
      <ImportDescription articleId={linkIDs.ImportCsvSuppliers} file={exampleFile} message={messages.helpContentText} />
      <InitErrors />
      <AddCsvFile name='supplier-import' />
      <FlexColumn className={styles['mapping-list-wrapper']}>
        <MappingList />
      </FlexColumn>
    </StepSuspense>
  );
};
